<template>
  <!--
    Was a hover-only reveal: the Switch button lived under a gradient scrim that only
    appeared on `mouseover`, so it was unreachable by keyboard and invisible to a screen
    reader. The whole row is the control now — one target, always present, and the swap
    affordance is a permanent icon that brightens on hover instead of a painted overlay.
  -->
  <button
    v-if="showShowCurrentAccountContext"
    class="flex items-center justify-between w-full gap-2 px-3 py-2.5 text-xs text-start rounded-lg outline-none border border-slate-100 bg-slate-25 transition-colors duration-200 ease-out group hover:bg-slate-50 hover:border-slate-200 focus-visible:ring-2 focus-visible:ring-accent-mint/70 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:bg-white/[0.03] dark:border-white/[0.06] dark:hover:bg-white/[0.07] dark:hover:border-white/10 dark:focus-visible:ring-offset-ink"
    @click="$emit('toggle-accounts')"
  >
    <!--
      Names the action without an aria-label, so the account name stays part of the
      accessible name and no bidi-neutral separator has to sit between two scripts.
    -->
    <span class="sr-only">{{ $t('SIDEBAR.SWITCH') }}</span>
    <span class="min-w-0">
      <span class="block text-slate-500 dark:text-slate-300">
        {{ $t('SIDEBAR.CURRENTLY_VIEWING_ACCOUNT') }}
      </span>
      <span
        :title="account.name"
        class="block mb-0 overflow-hidden text-sm font-medium text-slate-800 dark:text-slate-100 text-ellipsis whitespace-nowrap"
      >
        {{ account.name }}
      </span>
    </span>
    <fluent-icon
      icon="arrow-swap"
      size="14"
      class="flex-shrink-0 text-slate-500 dark:text-slate-300 transition-colors duration-200 ease-out group-hover:text-accent-mint dark:group-hover:text-accent-mint"
    />
  </button>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      account: 'getCurrentAccount',
      userAccounts: 'getUserAccounts',
    }),
    showShowCurrentAccountContext() {
      return this.userAccounts.length > 1 && this.account.name;
    },
  },
};
</script>
